export default __webpack_public_path__ + "static/media/gym.86a45136.svg";